import { ReactNode } from 'react';
import { pagesConfig } from '../../../shared/pages-config';

import Box from '@mui/material/Box';
import SharedTabContentCard from '../../../shared/shared-tab-content-card';
import SharedTabHeader from '../../../shared/shared-tab-header';

interface UserDetailsLayoutProps {
  tabsValue?: string;
  children?: ReactNode;
}

export default function UserDetailsLayout({
  tabsValue,
  children,
}: UserDetailsLayoutProps) {
  const matchingPage = Object.values(pagesConfig).find(
    (page) => page.link === tabsValue
  );

  const title = matchingPage?.name || tabsValue;

  return (
    <SharedTabContentCard
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        px: 4,
        py: 2,
        height: '100%',
      }}
    >
      {title && <SharedTabHeader title={title} noDivider />}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            my: 1,
          }}
        >
          {children}
        </Box>
      </Box>
    </SharedTabContentCard>
  );
}
